import { z } from 'zod';
import { QUOTAS } from './quotas.js';
import { SLUG_MAX, SLUG_MIN, SLUG_PATTERN } from './slug.js';
export const slugSchema = z
    .string()
    .min(SLUG_MIN)
    .max(SLUG_MAX)
    .regex(SLUG_PATTERN, 'lower-case letters, digits and hyphens only');
export const createAppSchema = z.object({
    slug: slugSchema,
    name: z.string().trim().min(1).max(80),
    type: z.enum(['static', 'server']),
});
export const envVarName = z.string().regex(/^[A-Z_][A-Z0-9_]{0,63}$/, 'UPPER_SNAKE_CASE');
export const putEnvSchema = z.object({
    /** Values are write-only: never returned by the API. Set a key to null to delete it. */
    vars: z
        .record(envVarName, z.string().max(4096).nullable())
        .refine((v) => Object.keys(v).length <= QUOTAS.envVarsPerApp, `at most ${QUOTAS.envVarsPerApp} variables`),
});
export const emailSchema = z.string().trim().toLowerCase().email().max(254);
export const putGrantsSchema = z.object({
    emails: z.array(emailSchema).min(1).max(QUOTAS.grantsPerApp),
});
export const deleteGrantSchema = z.object({ email: emailSchema });
export const createDeploymentSchema = z.object({
    /** Byte size of the zip, so the presigned PUT can enforce the quota. */
    size: z.number().int().positive().max(QUOTAS.uploadMaxBytes),
});
export const createBuilderSessionSchema = z.object({
    /** Optional first prompt, sent to the agent once the sandbox is running. */
    prompt: z.string().trim().max(8000).optional(),
});
export const agentMessageSchema = z.object({
    text: z.string().trim().min(1).max(20_000),
});
export const sessionHeartbeatSchema = z.object({
    tokensUsed: z.number().int().nonnegative().optional(),
});
//# sourceMappingURL=schemas.js.map